/** lingvanex.com mirrors our 20 UI locales at /{code}/… (English is
 * unprefixed), so outbound links can land the reader on the main site in
 * their own language. Verified against the live site: every footer/header
 * path exists for all 19 codes. The lone exception is /privacy-policy/,
 * which has no locale versions (any /{code}/privacy-policy/ 301s back to
 * the English page) — callers link it bare. */
export function lingvanexUrl(path: string, locale: string): string {
  const prefix = locale === 'en' ? '' : `/${locale}`
  return `https://lingvanex.com${prefix}${path}`
}
